import axios from "axios";
// не успел на всем сайте поправить
const http = axios.create({
  baseURL: ''
});

//https://luckygames.app

export default http